import styled from 'styled-components';
import { fontFamilyPrimary } from 'styles';

export const Wrapper = styled.input`
  border: 0;
  font-size: 16px;
  font-weight: 400;
  font-family: ${fontFamilyPrimary};
  line-height: 28px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;

  :focus {
    outline: none;
    text-overflow: clip;
  }

  ::placeholder {
    color: gray;
    font-size: 16px;
    font-weight: 400;
    line-height: 28px;
  }
`;

export default Wrapper;
